"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { FUSportsMatchEvent } from "fansunited-data-layer";
import { EventCard } from "./EventCard";
import { formatMinute, type EventLabels } from "./matchEventHelpers";
interface TimelineEventProps {
  event: FUSportsMatchEvent;
  isHome: boolean;
  showPhotos: boolean;
  eventLabels: EventLabels;
}

/**
 * TimelineEvent - Positions an event card on left or right of the timeline
 */
export const TimelineEvent: React.FC<TimelineEventProps> = t0 => {
  const $ = _c(22);
  const {
    event,
    isHome,
    showPhotos,
    eventLabels
  } = t0;
  let t1;
  if ($[0] !== event) {
    t1 = formatMinute(event);
    $[0] = event;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const minute = t1;
  let t2;
  if ($[2] !== event || $[3] !== eventLabels || $[4] !== isHome || $[5] !== showPhotos) {
    t2 = isHome && <EventCard event={event} showPhotos={showPhotos} eventLabels={eventLabels} />;
    $[2] = event;
    $[3] = eventLabels;
    $[4] = isHome;
    $[5] = showPhotos;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t2) {
    t3 = <div className="flex-1 flex justify-end pr-4">{t2}</div>;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== minute) {
    t4 = <div className="relative z-10 flex flex-col items-center"><div className="w-10 h-10 rounded-full bg-muted border-2 border-border flex items-center justify-center"><span className="text-xs font-bold text-foreground">{minute}</span></div></div>;
    $[9] = minute;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== event || $[12] !== eventLabels || $[13] !== isHome || $[14] !== showPhotos) {
    t5 = !isHome && <EventCard event={event} showPhotos={showPhotos} eventLabels={eventLabels} />;
    $[11] = event;
    $[12] = eventLabels;
    $[13] = isHome;
    $[14] = showPhotos;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== t5) {
    t6 = <div className="flex-1 flex justify-start pl-4">{t5}</div>;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== t3 || $[19] !== t4 || $[20] !== t6) {
    t7 = <div className="relative flex items-center">{t3}{t4}{t6}</div>;
    $[18] = t3;
    $[19] = t4;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  return t7;
};